import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { MouseEvent } from 'react'

import { Icon } from '@/components'
import useUrlParams from '@/hooks/useUrlParams'
import { Visibility } from '@/utils/api'

import {
  getArchiveSearchParams,
  resolveArchiveStatus,
} from './archiveSelectorUtils'

export const ArchiveSelector = () => {
  const [params, setSearchParams] = useUrlParams()
  const archiveStatus = resolveArchiveStatus(
    params.archiveStatus as Visibility | null | undefined
  )

  const changeView = (_: MouseEvent, vis: Visibility | null) => {
    setSearchParams(getArchiveSearchParams(vis))
  }

  return (
    <ToggleButtonGroup
      exclusive
      aria-label="display options as grid or list"
      sx={{ alignSelf: 'center' }}
      value={archiveStatus}
      onChange={changeView}
    >
      <ToggleButton value={Visibility.active}>
        <Icon name="view" />
      </ToggleButton>
      <ToggleButton value={Visibility.archived}>
        <Icon name="archived" />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
